import React from 'react';
import './AdaSkip.scss';

const AdaSkip = () => (
	<div id="ada-skip-container">
		<a href="#alert">Skip to Alerts</a>
		<a href="#headerNavigation">Skip to Main Navigation</a>
		<a href="#main">Skip to Main Content</a>
		<a href="#reach-out">Skip to Contact Us</a>
		<a href="#footer">Skip to Footer</a>
	</div>
);

export default AdaSkip;
